import { BDSColor } from '../tokens/color';
import { hexToRgba } from '../utils';

export const chatServiceColor = {
  static: {
    white: {
      role: '',
      bubblechat: {
        light: BDSColor.common.white,
        dark: BDSColor.common.white,
      },
      tingle: {
        light: BDSColor.common.white,
        dark: BDSColor.common.white,
      },
    },
    black: {
      role: '',
      bubblechat: {
        light: BDSColor.common.black,
        dark: BDSColor.common.black,
      },
      tingle: {
        light: BDSColor.common.black,
        dark: BDSColor.common.black,
      },
    },
    primary: {
      role: '',
      bubblechat: {
        light: BDSColor.aquamarine[50],
        dark: BDSColor.aquamarine[50],
      },
      tingle: {
        light: BDSColor.primary_pink[50],
        dark: BDSColor.primary_pink[50],
      },
    },
    secondary: {
      role: '',
      bubblechat: {
        light: BDSColor.purple[50],
        dark: BDSColor.purple[50],
      },
      tingle: {
        light: BDSColor.moody_blue[50],
        dark: BDSColor.moody_blue[50],
      },
    },
    warning: {
      role: '버블챗/팅글 경고문 색상',
      bubblechat: {
        light: BDSColor.pink[50],
        dark: BDSColor.pink[50],
      },
      tingle: {
        light: BDSColor.red[55],
        dark: BDSColor.red[55],
      },
    },
    adult: {
      role: '',
      bubblechat: {
        light: BDSColor.red[50],
        dark: BDSColor.red[50],
      },
      tingle: {
        light: BDSColor.red[55],
        dark: BDSColor.red[55],
      },
    },
  },
  field: {
    background: {
      role: '최하단에 깔리는 bg 색상',
      bubblechat: {
        light: BDSColor.common.white,
        dark: BDSColor.cool[75],
      },
      tingle: {
        light: BDSColor.common.white,
        dark: BDSColor.warm[75],
      },
    },
    side: {
      role: '사이드 메뉴에 깔리는 bg 색상',
      bubblechat: {
        light: BDSColor.variant[10],
        dark: BDSColor.cool[70],
      },
      tingle: {
        light: BDSColor.tingle_variant[10],
        dark: BDSColor.warm[70],
      },
    },
    rank: {
      role: 'Text',
      bubblechat: {
        light: BDSColor.variant[70],
        dark: '#000', // 미정
      },
      tingle: {
        light: BDSColor.tingle_variant[70],
        dark: '#000', // 미정
      },
    },
    sidebar: {
      role: '신규 대화방 슬라이드바 색상',
      bubblechat: {
        light: hexToRgba(BDSColor.common.white, 0.9),
        dark: hexToRgba(BDSColor.common.black, 0.9),
      },
      tingle: {
        light: hexToRgba(BDSColor.common.white, 0.9),
        dark: hexToRgba(BDSColor.common.black, 0.9),
      },
    },
    textBox: {
      role: '신규 대화방 텍스트 영역',
      bubblechat: {
        light: hexToRgba(BDSColor.common.white, 0.8),
        dark: hexToRgba(BDSColor.common.black, 0.7),
      },
      tingle: {
        light: hexToRgba(BDSColor.common.white, 0.8),
        dark: hexToRgba(BDSColor.common.black, 0.7),
      },
    },
    content: {
      role: '콘텐츠 필드 색상',
      bubblechat: {
        light: BDSColor.variant[10],
        dark: BDSColor.cool[70],
      },
      tingle: {
        light: BDSColor.tingle_variant[10],
        dark: BDSColor.warm[70],
      },
    },
    input: {
      role: '인풋 필드 색상',
      bubblechat: {
        light: BDSColor.variant[15],
        dark: BDSColor.cool[65],
      },
      tingle: {
        light: BDSColor.tingle_variant[15],
        dark: BDSColor.warm[65],
      },
    },
    profile: {
      role: '프로필 bg 색상',
      bubblechat: {
        light: BDSColor.variant[10],
        dark: 'rgba(0,0,0,0.6)', // 미정
      },
      tingle: {
        light: BDSColor.tingle_variant[10],
        dark: 'rgba(0,0,0,0.6)', // 미정
      },
    },
    toast: {
      role: '',
      bubblechat: {
        light: BDSColor.cool[35],
        dark: BDSColor.cool[55],
      },
      tingle: {
        light: BDSColor.warm[35],
        dark: BDSColor.warm[55],
      },
    },
    scroll: {
      role: '',
      bubblechat: {
        light: hexToRgba(BDSColor.common.white, 0.2),
        dark: hexToRgba(BDSColor.cool[75], 0.2),
      },
      tingle: {
        light: hexToRgba(BDSColor.common.white, 0.2),
        dark: hexToRgba(BDSColor.warm[75], 0.2),
      },
    },
    thumbnail: {
      role: '프로필 bg 색상',
      bubblechat: {
        light: BDSColor.neutral[10],
        dark: BDSColor.cool[70],
      },
      tingle: {
        light: BDSColor.neutral[10],
        dark: BDSColor.warm[70],
      },
    },
  },
  buttons: {
    default: {
      role: '기본 버튼 색상',
      bubblechat: {
        light: BDSColor.neutral[20],
        dark: BDSColor.cool[50],
      },
      tingle: {
        light: BDSColor.neutral[20],
        dark: BDSColor.warm[50],
      },
    },
    hover: {
      role: '기본 버튼 마우스 호버 시',
      bubblechat: {
        light: BDSColor.neutral[10],
        dark: BDSColor.cool[55],
      },
      tingle: {
        light: BDSColor.neutral[10],
        dark: BDSColor.warm[55],
      },
    },
    press: {
      role: '기본 버튼 클릭 시',
      bubblechat: {
        light: BDSColor.variant[30],
        dark: BDSColor.cool[60],
      },
      tingle: {
        light: BDSColor.tingle_variant[30],
        dark: BDSColor.warm[60],
      },
    },
    disable: {
      role: '기본 버튼 사용 불가',
      bubblechat: {
        light: BDSColor.neutral[30],
        dark: BDSColor.cool[70],
      },
      tingle: {
        light: BDSColor.neutral[30],
        dark: BDSColor.warm[70],
      },
    },
    sbtn_default: {
      role: '서브 버튼 기본 색상',
      bubblechat: {
        light: BDSColor.variant[45],
        dark: BDSColor.cool[55],
      },
      tingle: {
        light: BDSColor.tingle_variant[45],
        dark: BDSColor.warm[55],
      },
    },
    sbtn_hover: {
      role: '서브 버튼 마우스 호버 시',
      bubblechat: {
        light: BDSColor.variant[35],
        dark: BDSColor.cool[50],
      },
      tingle: {
        light: BDSColor.tingle_variant[35],
        dark: BDSColor.warm[50],
      },
    },
    sbtn_press: {
      role: '서브 버튼 클릭 시',
      bubblechat: {
        light: BDSColor.variant[50],
        dark: BDSColor.variant[50],
      },
      tingle: {
        light: BDSColor.tingle_variant[50],
        dark: BDSColor.tingle_variant[50],
      },
    },
    thbtn_default: {
      role: '3순위 버튼 색상',
      bubblechat: {
        light: BDSColor.variant[55],
        dark: BDSColor.variant[70],
      },
      tingle: {
        light: BDSColor.tingle_variant[55],
        dark: BDSColor.tingle_variant[70],
      },
    },
    btn_light: {
      role: '팔로잉 버튼 색상',
      bubblechat: {
        light: BDSColor.aquamarine[0],
        dark: BDSColor.aquamarine[0],
      },
      tingle: {
        light: BDSColor.primary_pink[5],
        dark: BDSColor.primary_pink[5],
      },
    },
    btn_highlight: {
      role: '충전소 내 강조 버튼, 텍스트 색상',
      bubblechat: {
        light: BDSColor.pink[50],
        dark: BDSColor.pink[50],
      },
      tingle: {
        light: BDSColor.moody_blue[50],
        dark: BDSColor.moody_blue[50],
      },
    },
    toggle: {
      role: '토글 버튼 색상',
      bubblechat: {
        light: BDSColor.neutral[20],
        dark: BDSColor.cool[60],
      },
      tingle: {
        light: BDSColor.neutral[20],
        dark: BDSColor.warm[60],
      },
    },
    mode_hover: {
      role: '라이트/ 다크 모드 변환 마우스 호버 시',
      bubblechat: {
        light: BDSColor.neutral[10],
        dark: BDSColor.cool[70],
      },
      tingle: {
        light: BDSColor.neutral[10],
        dark: BDSColor.warm[70],
      },
    },
  },
  sideMenu: {
    menu_hover: {
      role: '사이드 메뉴 호버 시',
      bubblechat: {
        light: BDSColor.cool[5],
        dark: BDSColor.cool[55],
      },
      tingle: {
        light: BDSColor.warm[5],
        dark: BDSColor.warm[55],
      },
    },
    menu_active: {
      role: '사이드 메뉴 클릭 시',
      bubblechat: {
        light: BDSColor.cool[10],
        dark: BDSColor.cool[60],
      },
      tingle: {
        light: BDSColor.warm[10],
        dark: BDSColor.warm[60],
      },
    },
    new: {
      role: '만들기 버튼 기본 색상',
      bubblechat: {
        light: BDSColor.skyblue_default[25],
        // dark: BDSColor.skyblue_dark[25],
        dark: BDSColor.skyblue_dark[50],
      },
      tingle: {
        light: BDSColor.pink_dark[25],
        dark: BDSColor.pink_dark[25],
      },
    },
    new_hover: {
      role: '만들기 버튼 마우스 호버 시',
      bubblechat: {
        light: BDSColor.skyblue_default[50],
        // dark: BDSColor.skyblue_dark[50],
        dark: BDSColor.skyblue_dark[25],
      },
      tingle: {
        light: BDSColor.pink[55],
        dark: BDSColor.pink_dark[50],
      },
    },
  },
  item: {
    badge: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.variant[65],
        dark: '#000', // 미정
      },
      tingle: {
        light: BDSColor.tingle_variant[65],
        dark: '#000', // 미정
      },
    },
    review: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.skyblue_default[5],
        dark: BDSColor.skyblue_default[5],
      },
      tingle: {
        light: BDSColor.pink_dark[5],
        dark: BDSColor.pink_dark[5],
      },
    },
    list_hover: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.neutral[10],
        dark: BDSColor.cool[70],
      },
      tingle: {
        light: BDSColor.neutral[10],
        dark: BDSColor.warm[70],
      },
    },
    tag: {
      role: '태그 bg 색상',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.variant[15],
        dark: BDSColor.cool[65],
      },
      tingle: {
        light: BDSColor.tingle_variant[15],
        dark: BDSColor.warm[55],
      },
    },
    tag_edit: {
      role: '편집 가능한 태그 bg 색상',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.variant[30],
        dark: BDSColor.cool[60],
      },
      tingle: {
        light: BDSColor.tingle_variant[30],
        dark: BDSColor.warm[60],
      },
    },
    using_tag: {
      role: '사용 중 태그 bg 색상',
      sub_description: 'Text',
      bubblechat: {
        light: hexToRgba('#63C6FC', 0.2),
        dark: hexToRgba('#63C6FC', 0.2),
      },
      tingle: {
        light: hexToRgba('#63C6FC', 0.2),
        dark: hexToRgba('#63C6FC', 0.2),
      },
    },
    highlight: {
      role: '충전소 내 강조 버튼, 텍스트 색상',
      bubblechat: {
        light: BDSColor.cobalt_blue[50],
        dark: BDSColor.cobalt_blue[50],
      },
      tingle: {
        light: BDSColor.magenta[50],
        dark: BDSColor.magenta[50],
      },
    },
    // item/label
    lt_green: {
      role: '라벨 Text 색상(LLM 모델 라벨)',
      bubblechat: {
        light: BDSColor.green[50],
        dark: BDSColor.green[50],
      },
      tingle: {
        light: BDSColor.green[50],
        dark: BDSColor.green[50],
      },
    },
    lt_aquamarine: {
      role: '라벨 Text 색상(LLM 모델 라벨)',
      bubblechat: {
        light: BDSColor.aquamarine[50],
        dark: BDSColor.aquamarine[50],
      },
      tingle: {
        light: BDSColor.primary_pink[50],
        dark: BDSColor.primary_pink[50],
      },
    },
    lt_blue: {
      role: '라벨 Text 색상(LLM 모델 라벨)',
      bubblechat: {
        light: BDSColor.cobalt_blue[25],
        dark: BDSColor.cobalt_blue[25],
      },
      tingle: {
        light: BDSColor.red[50],
        dark: BDSColor.red[50],
      },
    },
    lt_purple: {
      role: '라벨 Text 색상(LLM 모델 라벨)',
      bubblechat: {
        light: BDSColor.purple[20],
        dark: BDSColor.purple[20],
      },
      tingle: {
        light: BDSColor.purple[20],
        dark: BDSColor.purple[20],
      },
    },
    lt_magenta: {
      role: '라벨 Text 색상(LLM 모델 라벨)',
      bubblechat: {
        light: BDSColor.magenta[40],
        dark: BDSColor.magenta[40],
      },
      tingle: {
        light: BDSColor.magenta[40],
        dark: BDSColor.magenta[40],
      },
    },
    lt_red: {
      role: '라벨 Text 색상(LLM 모델 라벨)',
      bubblechat: {
        light: BDSColor.primary_pink[50],
        dark: BDSColor.primary_pink[50],
      },
      tingle: {
        light: BDSColor.aquamarine[50],
        dark: BDSColor.aquamarine[50],
      },
    },
    lt_black: {
      role: '라벨 Text 색상(LLM 모델 라벨)',
      bubblechat: {
        light: BDSColor.common.black,
        dark: BDSColor.common.white,
      },
      tingle: {
        light: BDSColor.common.black,
        dark: BDSColor.common.white,
      },
    },
    lb_green: {
      role: '라벨 bg 색상(LLM 모델 라벨)',
      bubblechat: {
        light: hexToRgba(BDSColor.green[50], 0.1),
        dark: hexToRgba(BDSColor.green[50], 0.1),
      },
      tingle: {
        light: hexToRgba(BDSColor.green[50], 0.1),
        dark: hexToRgba(BDSColor.green[50], 0.1),
      },
    },
    lb_aquamarine: {
      role: '라벨 bg 색상(LLM 모델 라벨)',
      bubblechat: {
        light: hexToRgba(BDSColor.aquamarine[50], 0.08),
        dark: hexToRgba(BDSColor.aquamarine[50], 0.08),
      },
      tingle: {
        light: hexToRgba(BDSColor.primary_pink[50], 0.08),
        dark: hexToRgba(BDSColor.primary_pink[50], 0.08),
      },
    },
    lb_blue: {
      role: '라벨 bg 색상(LLM 모델 라벨)',
      bubblechat: {
        light: hexToRgba(BDSColor.cobalt_blue[25], 0.1),
        dark: hexToRgba(BDSColor.cobalt_blue[25], 0.1),
      },
      tingle: {
        light: hexToRgba(BDSColor.red[50], 0.1),
        dark: hexToRgba(BDSColor.red[50], 0.1),
      },
    },
    lb_purple: {
      role: '라벨 bg 색상(LLM 모델 라벨)',
      bubblechat: {
        light: hexToRgba(BDSColor.purple[20], 0.1),
        dark: hexToRgba(BDSColor.purple[20], 0.1),
      },
      tingle: {
        light: hexToRgba(BDSColor.purple[20], 0.1),
        dark: hexToRgba(BDSColor.purple[20], 0.1),
      },
    },
    lb_magenta: {
      role: '라벨 bg 색상(LLM 모델 라벨)',
      bubblechat: {
        light: hexToRgba(BDSColor.magenta[40], 0.1),
        dark: hexToRgba(BDSColor.magenta[40], 0.1),
      },
      tingle: {
        light: hexToRgba(BDSColor.magenta[40], 0.1),
        dark: hexToRgba(BDSColor.magenta[40], 0.1),
      },
    },
    lb_red: {
      role: '라벨 bg 색상(LLM 모델 라벨)',
      bubblechat: {
        light: hexToRgba(BDSColor.primary_pink[50], 0.08),
        dark: hexToRgba(BDSColor.primary_pink[50], 0.08),
      },
      tingle: {
        light: hexToRgba(BDSColor.aquamarine[50], 0.08),
        dark: hexToRgba(BDSColor.aquamarine[50], 0.08),
      },
    },
    lb_black: {
      role: '라벨 bg 색상(LLM 모델 라벨)',
      bubblechat: {
        light: hexToRgba(BDSColor.common.black, 0.05),
        dark: hexToRgba(BDSColor.common.white, 0.1),
      },
      tingle: {
        light: hexToRgba(BDSColor.common.black, 0.05),
        dark: hexToRgba(BDSColor.common.white, 0.1),
      },
    },
    lb_gray: {
      role: '멀티이미지 썸네일 색상',
      bubblechat: {
        light: BDSColor.neutral[10],
        dark: BDSColor.neutral[10],
      },
      tingle: {
        light: BDSColor.neutral[10],
        dark: BDSColor.neutral[10],
      },
    },
    lb_gradient1: {
      role: '후원 라벨 색상1',
      bubblechat: {
        light: BDSColor.purple[55],
        dark: BDSColor.purple[55],
      },
      tingle: {
        light: BDSColor.magenta[45],
        dark: BDSColor.magenta[45],
      },
    },
    lb_gradient2: {
      role: '후원 라벨 색상2',
      bubblechat: {
        light: BDSColor.magenta[60],
        dark: BDSColor.magenta[60],
      },
      tingle: {
        light: BDSColor.purple[25],
        dark: BDSColor.purple[25],
      },
    },
    // item/Station
    stationGreen: {
      role: '라벨 배경 색상(무료 충전소 버튼)',
      bubblechat: {
        light: BDSColor.green[50],
        dark: BDSColor.green[50],
      },
      tingle: {
        light: BDSColor.green[50],
        dark: BDSColor.green[50],
      },
    },
    stationYellow: {
      role: '라벨 배경 색상(무료 충전소 버튼)',
      bubblechat: {
        light: BDSColor.gold[20],
        dark: BDSColor.gold[20],
      },
      tingle: {
        light: BDSColor.gold[20],
        dark: BDSColor.gold[20],
      },
    },
    stationPurple: {
      role: '라벨 배경 색상(무료 충전소 버튼)',
      bubblechat: {
        light: BDSColor.purple[50],
        dark: BDSColor.purple[50],
      },
      tingle: {
        light: BDSColor.purple[50],
        dark: BDSColor.purple[50],
      },
    },
    stationBlue: {
      role: '라벨 배경 색상(무료 충전소 버튼)',
      bubblechat: {
        light: BDSColor.aquamarine[50],
        dark: BDSColor.aquamarine[50],
      },
      tingle: {
        light: BDSColor.aquamarine[50],
        dark: BDSColor.aquamarine[50],
      },
    },
    stationPink: {
      role: '라벨 배경 색상(무료 충전소 버튼)',
      bubblechat: {
        light: BDSColor.magenta[50],
        dark: BDSColor.magenta[50],
      },
      tingle: {
        light: BDSColor.magenta[50],
        dark: BDSColor.magenta[50],
      },
    },
    writer: {
      role: 'writer 버튼 색상',
      bubblechat: {
        light: hexToRgba(BDSColor.cool[0], 0.24),
        dark: hexToRgba(BDSColor.cool[0], 0.24),
      },
      tingle: {
        light: hexToRgba(BDSColor.warm[0], 0.24),
        dark: hexToRgba(BDSColor.warm[0], 0.24),
      },
    },
  },
  message: {
    talk_mode: {
      character: {
        role: '캐릭터의 말풍선 bg 색상',
        bubblechat: {
          light: BDSColor.cool[10],
          dark: BDSColor.cool[55],
        },
        tingle: {
          light: BDSColor.warm[55],
          dark: BDSColor.warm[55],
        },
      },
      user: {
        role: '사용자의 말풍선 bg 색상',
        bubblechat: {
          light: BDSColor.variant[15],
          dark: BDSColor.cool[60],
        },
        tingle: {
          light: BDSColor.warm[60],
          dark: BDSColor.warm[60],
        },
      },
      action: {
        role: '지문 bg 색상',
        bubblechat: {
          light: BDSColor.variant[5],
          dark: BDSColor.cool[70],
        },
        tingle: {
          light: BDSColor.tingle_variant[5],
          dark: BDSColor.warm[70],
        },
      },
    },
    novel_mode: {
      character: {
        role: '캐릭터 TEXT 색상',
        bubblechat: {
          light: BDSColor.red[80],
          dark: BDSColor.gold[18],
        },
        tingle: {
          light: BDSColor.gold[18],
          dark: BDSColor.gold[18],
        },
      },
      user: {
        role: '사용자 TEXT 색상',
        bubblechat: {
          light: BDSColor.green[80],
          dark: BDSColor.aquamarine[55],
        },
        tingle: {
          light: BDSColor.aquamarine[55],
          dark: BDSColor.aquamarine[55],
        },
      },
      narrative: {
        role: '지문 색상',
        bubblechat: {
          light: BDSColor.neutral[70],
          dark: BDSColor.neutral[30],
        },
        tingle: {
          light: BDSColor.neutral[30],
          dark: BDSColor.neutral[30],
        },
      },
    },
  },
  popup: {
    background: {
      role: '팝업 bg 색상',
      bubblechat: {
        light: BDSColor.common.white,
        dark: BDSColor.cool[65],
      },
      tingle: {
        light: BDSColor.common.white,
        dark: BDSColor.warm[65],
      },
    },
    content: {
      role: '팝업 내의 콘텐츠 필드 색상',
      bubblechat: {
        light: BDSColor.variant[15],
        dark: BDSColor.cool[70],
      },
      tingle: {
        light: BDSColor.tingle_variant[15],
        dark: BDSColor.warm[70],
      },
    },
    popup: {
      role: '팝업 내의 팝업 bg 색상',
      bubblechat: {
        light: BDSColor.common.white,
        dark: BDSColor.cool[60],
      },
      tingle: {
        light: BDSColor.common.white,
        dark: BDSColor.warm[60],
      },
    },
    background_dark: {
      role: '신규 유저 플로우 팝업 bg 색상',
      bubblechat: {
        light: BDSColor.cool[65],
        dark: BDSColor.cool[65],
      },
      tingle: {
        light: BDSColor.warm[65],
        dark: BDSColor.warm[65],
      },
    },
    content_dark: {
      role: '신규 유저 플로우 팝업 내의 콘텐츠 필드 색상',
      bubblechat: {
        light: BDSColor.cool[70],
        dark: BDSColor.cool[70],
      },
      tingle: {
        light: BDSColor.warm[70],
        dark: BDSColor.warm[70],
      },
    },
    input: {
      role: '팝업 내의 인풋 bg 색상',
      bubblechat: {
        light: BDSColor.neutral[15],
        dark: BDSColor.cool[70],
      },
      tingle: {
        light: BDSColor.neutral[15],
        dark: BDSColor.warm[70],
      },
    },
    btn_hover: {
      role: '팝업 내의 버튼 마우스 호버 시',
      bubblechat: {
        light: BDSColor.neutral[10],
        dark: BDSColor.cool[55],
      },
      tingle: {
        light: BDSColor.neutral[10],
        dark: BDSColor.warm[55],
      },
    },
    btn_disable: {
      role: '팝업 내의 버튼 사용 불가',
      bubblechat: {
        light: BDSColor.neutral[30],
        dark: BDSColor.cool[55], // 확인 필요
      },
      tingle: {
        light: BDSColor.neutral[30],
        dark: BDSColor.warm[55], // 확인 필요
      },
    },
    btn_TXT: {
      role: '팝업 내의 버튼 텍스트 색상',
      bubblechat: {
        light: BDSColor.common.white,
        dark: BDSColor.variant[60],
      },
      tingle: {
        light: BDSColor.common.white,
        dark: BDSColor.tingle_variant[60],
      },
    },
    list_hover: {
      role: '팝업 내의 리스트 아이템 마우스 호버 시',
      bubblechat: {
        light: BDSColor.neutral[10],
        dark: BDSColor.cool[60],
      },
      tingle: {
        light: BDSColor.tingle_variant[10],
        dark: BDSColor.warm[60],
      },
    },
    line_1: {
      role: '팝업 내의 라인 1',
      bubblechat: {
        light: BDSColor.variant[15],
        dark: BDSColor.cool[60],
      },
      tingle: {
        light: BDSColor.tingle_variant[15],
        dark: BDSColor.warm[60],
      },
    },
    line_2: {
      role: '팝업 내의 라인 2',
      bubblechat: {
        light: BDSColor.variant[25],
        dark: BDSColor.cool[55],
      },
      tingle: {
        light: BDSColor.tingle_variant[25],
        dark: BDSColor.warm[55],
      },
    },
    icon_2: {
      role: '팝업 내의 아이콘 2',
      bubblechat: {
        light: BDSColor.tingle_variant[40],
        dark: BDSColor.cool[45],
      },
      tingle: {
        light: BDSColor.tingle_variant[40],
        dark: BDSColor.warm[45],
      },
    },
    icon_4: {
      role: '팝업 내의 아이콘 4',
      bubblechat: {
        light: BDSColor.variant[15],
        dark: BDSColor.cool[60],
      },
      tingle: {
        light: BDSColor.tingle_variant[15],
        dark: BDSColor.warm[60],
      },
    },
    icon_5: {
      role: '팝업 내의 아이콘 5',
      bubblechat: {
        light: BDSColor.variant[60],
        dark: BDSColor.neutral[40],
      },
      tingle: {
        light: BDSColor.tingle_variant[60],
        dark: BDSColor.neutral[40],
      },
    },
    tag_default: {
      role: '팝업 내의 태그 bg 색상',
      bubblechat: {
        light: BDSColor.variant[15],
        dark: BDSColor.cool[60],
      },
      tingle: {
        light: BDSColor.tingle_variant[15],
        dark: BDSColor.warm[60],
      },
    },
    tag_edit: {
      role: '팝업 내의 태그 편집 bg 색상',
      bubblechat: {
        light: BDSColor.variant[30],
        dark: BDSColor.cool[55],
      },
      tingle: {
        light: BDSColor.tingle_variant[30],
        dark: BDSColor.warm[55],
      },
    },
  },
  icon: {
    icon_1: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.variant[35],
        dark: BDSColor.cool[60],
      },
      tingle: {
        light: BDSColor.tingle_variant[35],
        dark: BDSColor.warm[60],
      },
    },
    icon_2: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.cool[60],
        dark: BDSColor.neutral[15],
      },
      tingle: {
        light: BDSColor.warm[60],
        dark: BDSColor.neutral[15],
      },
    },
    icon_3: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.variant[40],
        dark: BDSColor.cool[55],
      },
      tingle: {
        light: BDSColor.tingle_variant[40],
        dark: BDSColor.warm[55],
      },
    },
    icon_4: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.common.black,
        dark: BDSColor.common.white,
      },
      tingle: {
        light: BDSColor.common.black,
        dark: BDSColor.common.white,
      },
    },
    icon_5: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.variant[15],
        dark: BDSColor.cool[65],
      },
      tingle: {
        light: BDSColor.tingle_variant[15],
        dark: BDSColor.warm[65],
      },
    },
    icon_6: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.variant[60],
        dark: BDSColor.neutral[40],
      },
      tingle: {
        light: BDSColor.tingle_variant[60],
        dark: BDSColor.neutral[40],
      },
    },
    icon_7: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.neutral[40],
        dark: BDSColor.variant[20],
      },
      tingle: {
        light: BDSColor.neutral[40],
        dark: BDSColor.tingle_variant[20],
      },
    },
    bookmark: {
      role: '포인트 컬러',
      bubblechat: {
        light: BDSColor.cool[10],
        dark: '#000', // 미정
      },
      tingle: {
        light: BDSColor.warm[10],
        dark: '#000', // 미정
      },
    },
  },
  line: {
    line_1: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.variant[15],
        dark: BDSColor.cool[70],
      },
      tingle: {
        light: BDSColor.tingle_variant[15],
        dark: BDSColor.warm[70],
      },
    },
    line_2: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.variant[25],
        dark: BDSColor.cool[60],
      },
      tingle: {
        light: BDSColor.tingle_variant[25],
        dark: BDSColor.warm[60],
      },
    },
    line_3: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.neutral[20],
        dark: BDSColor.cool[55],
      },
      tingle: {
        light: BDSColor.neutral[20],
        dark: BDSColor.warm[55],
      },
    },
    line_4: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: BDSColor.cool[10],
        dark: BDSColor.cool[50],
      },
      tingle: {
        light: BDSColor.warm[10],
        dark: BDSColor.warm[50],
      },
    },
    line_5: {
      role: 'Text',
      sub_description: 'Text',
      bubblechat: {
        light: hexToRgba(BDSColor.common.black, 0.2),
        dark: hexToRgba(BDSColor.common.white, 0.2),
      },
      tingle: {
        light: hexToRgba(BDSColor.common.black, 0.2),
        dark: hexToRgba(BDSColor.common.white, 0.2),
      },
    },
    line_6: {
      role: '프로필 라인 색상',
      sub_description: '유저 프로필',
      bubblechat: {
        light: hexToRgba(BDSColor.neutral[20], 0.8),
        dark: hexToRgba(BDSColor.cool[55], 0.8),
      },
      tingle: {
        light: hexToRgba(BDSColor.neutral[20], 0.8),
        dark: hexToRgba(BDSColor.warm[55], 0.8),
      },
    },
  },
  text: {
    default: {
      role: '기본 텍스트 색상',
      bubblechat: {
        light: BDSColor.common.black,
        dark: BDSColor.common.white,
      },
      tingle: {
        light: BDSColor.common.black,
        dark: BDSColor.common.white,
      },
    },
    TXT_0: {
      role: '중요도가 낮은 텍스트 색상',
      sub_description: 'Input Field의 가이드 텍스트 컬러',
      bubblechat: {
        light: BDSColor.neutral[30],
        dark: BDSColor.neutral[50],
      },
      tingle: {
        light: BDSColor.neutral[30],
        dark: BDSColor.neutral[50],
      },
    },
    TXT_1: {
      role: '텍스트가 밀집된 영역에서 중요도가 낮은 텍스트의 컬러',
      sub_description: 'Info text, sub text',
      bubblechat: {
        light: BDSColor.neutral[40],
        dark: BDSColor.neutral[40],
      },
      tingle: {
        light: BDSColor.neutral[40],
        dark: BDSColor.neutral[40],
      },
    },
    TXT_2: {
      role: '본문 텍스트에 사용되는 색상',
      sub_description: '본문',
      bubblechat: {
        light: BDSColor.neutral[45],
        dark: BDSColor.neutral[30],
      },
      tingle: {
        light: BDSColor.neutral[45],
        dark: BDSColor.neutral[30],
      },
    },
    TXT_3: {
      role: '본문보다 상위 레벨의 텍스트에 사용되는 색상',
      sub_description: '메뉴 타이틀 등',
      bubblechat: {
        light: BDSColor.neutral[55],
        dark: BDSColor.neutral[25],
      },
      tingle: {
        light: BDSColor.neutral[55],
        dark: BDSColor.neutral[25],
      },
    },
    TXT_4: {
      role: '페이지에서 상위 레벨의 중요도를 갖는 텍스트에 사용되는 색상',
      sub_description: '타이틀',
      bubblechat: {
        light: BDSColor.neutral[70],
        dark: BDSColor.common.white,
      },
      tingle: {
        light: BDSColor.neutral[70],
        dark: BDSColor.common.white,
      },
    },
    disable: {
      role: '중요도 최하 텍스트에 사용되는 색상',
      sub_description: '거의 사용되지 않음',
      bubblechat: {
        light: hexToRgba(BDSColor.neutral[70], 0.6),
        dark: hexToRgba(BDSColor.common.white, 0.6),
      },
      tingle: {
        light: hexToRgba(BDSColor.neutral[70], 0.6),
        dark: hexToRgba(BDSColor.common.white, 0.6),
      },
      // light: 'rgba(19, 20, 21, 0.6)',
      // dark: 'rgba(255, 255, 255, 0.6)',
    },
    info: {
      role: 'Info',
      sub_description: 'AI 모델 선택 모달 > 사용 중, 버블 표시 텍스트',
      bubblechat: {
        light: '#229BDC',
        dark: '#229BDC',
      },
      tingle: {
        light: '#229BDC',
        dark: '#229BDC',
      },
    },
  },
  app: {
    icon: {
      icon_1: {
        role: 'text',
        bubblechat: {
          light: BDSColor.neutral[30],
          dark: BDSColor.neutral[48],
        },
        tingle: {
          light: BDSColor.neutral[48],
          dark: BDSColor.neutral[48],
        },
      },
      icon_2: {
        role: 'text',
        bubblechat: {
          light: BDSColor.neutral[38],
          dark: BDSColor.neutral[38],
        },
        tingle: {
          light: BDSColor.neutral[38],
          dark: BDSColor.neutral[38],
        },
      },
      icon_3: {
        role: 'text',
        bubblechat: {
          light: BDSColor.neutral[55],
          dark: BDSColor.neutral[20],
        },
        tingle: {
          light: BDSColor.neutral[20],
          dark: BDSColor.neutral[20],
        },
      },
      icon_4: {
        role: 'text',
        bubblechat: {
          light: BDSColor.cool[60],
          dark: BDSColor.variant[15],
        },
        tingle: {
          light: BDSColor.warm[5],
          dark: BDSColor.warm[5],
        },
      },
    },
    buttons: {
      default: {
        role: 'text',
        bubblechat: {
          light: BDSColor.variant[25],
          dark: BDSColor.neutral[55],
        },
        tingle: {
          light: BDSColor.neutral[55],
          dark: BDSColor.neutral[55],
        },
      },
    },
    text: {
      default: {
        role: '기본 텍스트 색상',
        bubblechat: {
          light: BDSColor.common.black,
          dark: BDSColor.common.white,
        },
        tingle: {
          light: BDSColor.common.white,
          dark: BDSColor.common.white,
        },
      },
      TXT_0: {
        role: '중요도가 낮은 텍스트 색상',
        sub_description: 'Input Field의 가이드 텍스트 컬러',
        bubblechat: {
          light: BDSColor.neutral[30],
          dark: BDSColor.neutral[38],
        },
        tingle: {
          light: BDSColor.neutral[38],
          dark: BDSColor.neutral[38],
        },
      },
      TXT_1: {
        role: '텍스트가 밀집된 영역에서 중요도가 낮은 텍스트의 컬럼',
        sub_description: 'Info text, sub text',
        bubblechat: {
          light: BDSColor.neutral[38],
          dark: BDSColor.neutral[30],
        },
        tingle: {
          light: BDSColor.neutral[30],
          dark: BDSColor.neutral[30],
        },
      },
      TXT_2: {
        role: '본문 텍스트에 사용되는 색상',
        sub_description: '본문',
        bubblechat: {
          light: BDSColor.neutral[55],
          dark: BDSColor.neutral[18],
        },
        tingle: {
          light: BDSColor.neutral[18],
          dark: BDSColor.neutral[18],
        },
      },
      TXT_3: {
        role: '본문보다 상위 레벨의 텍스트에 사용되는 색상',
        sub_description: '메뉴 타이틀 등',
        bubblechat: {
          light: BDSColor.neutral[70],
          dark: BDSColor.neutral[8],
        },
        tingle: {
          light: BDSColor.neutral[8],
          dark: BDSColor.neutral[8],
        },
      },
    },
  },
};
